import React from 'react'

import { Modal, Header, Button, Icon } from 'semantic-ui-react'
import {connect} from 'react-redux'

function mapStateToProps (state) {
   return {}
}

class DayLabel extends React.Component {
	render() {
		return (
			<div style={{
				height: '20px',
				display: 'inline-block',
				backgroundColor: '#eeeeee',
				padding: '1px 4px',
				borderRadius: '6px',
				lineHeight: '20px',
				verticalAlign: 'middle'
			}}>{this.props.time}</div>
		)
	}
}

class TimelineComponent extends React.Component {
	render() {
		const time = ['0:00', '6:00', '12:00', '18:00'];
		
		return (
			<div style={{
				height: '60px',
				backgroundColor: '#EEEEEE',
				borderBottom: '1px solid #CCCCCC',
				display: 'flex'
			}}>
				<div style={{
					flexGrow: 0,
					width: this.props['width-before'],
					overflow: 'hidden'
				}}>
					<Button onClick={(e) => this.props.prev()} attached='left' icon compact style={{
						width: '100%',
						borderRadius: '0px',
						lineHeight: '30px',
						height: '100%'
					}}><Icon name="caret left" /></Button>
				</div>
				<div style={{
					flexGrow: 1,
					display: 'flex',
					borderLeft: '1px solid #999999'
				}}>
				{
					this.props.timespan.days.map((day, dayIdx) => {
                        day = day.toJS();

						return (
							<div key={dayIdx} style={{
								width: (100 / this.props.timespan.seconds * day.seconds) + '%',
								textAlign: 'center',
								borderRight: '1px solid #999999',
								paddingTop: '3px',
								position: 'relative',
								pointerEvents: 'none'
							}}>
								{day.caption}
								<div style={{
										position: 'absolute',
										'bottom': 0,
										width: '100%'
								}}>
								{
									time.map((t) => {
										return (
											<div key={t} style={{
												fontSize: '80%',
												height: '30px',
												display: 'inline-block',
												width: (Math.floor(10000 / 4) / 100) + '%',
												position: 'relative',
												left: (Math.floor(10000 / 8) / -100) + '%',
												textAlign: 'center'
											}}>
												{
													(dayIdx !== 0 || t !== '0:00')
														?<DayLabel time={t}/>
													:null
												}
												{
													(t !== '0:00')?
														<div style={{
															borderLeft: '1px solid #999999',
															width: '50%',
															height: '10px',
															marginLeft: '50%'
														}}></div>
													:null
												}
											</div>
										)
									})	
								}
								</div>
								
							</div>
						)	
					})	
				}
				</div>
				<div style={{
					width: this.props['width-after'],
					flexGrow: 0
				}}>
					<Button onClick={(e) => this.props.next()} attached='left' icon compact style={{
						width: '100%',
						borderRadius: '0px',
						lineHeight: '30px',
						height: '100%'
					}}><Icon name="caret right" /></Button>
				</div>
			</div>
		)
	}
};

export const Timeline = connect(
  mapStateToProps
)(TimelineComponent)